import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { setLang2Eng,setLang2Fr } from '../Contexts/lang/langueSlice';

const usePersistedLanguage = () => {
    const { i18n } = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const lang = urlParams.get('lang');

        if (lang) {
            i18n.changeLanguage(lang);
            if (lang === 'en') {
                dispatch(setLang2Eng());
            } else {
                dispatch(setLang2Fr());
            }
        }
    }, [i18n, dispatch]);
};

export default usePersistedLanguage;